import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {catchError,  map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {Client, LoadCurrentClientSuccessAction, SendBackResult} from '../../shared';
import {L10nTranslationService} from 'angular-l10n';
import {
  AddInvoiceManagementAction,
  addInvoiceManagementActionTypes,
  AddInvoiceManagementFailAction,
  AddInvoiceManagementSuccessAction
} from '../actions/invoice-management';
import {ContractLinkServiceService} from '../services/contract-link.service';
import {InvoicesManagementService} from '../services/invoices-management.service';
import {LoadSubByClientListAction, LoadSubListAction} from '../actions/subscription-list';
import {ProjectEditAction, projectEditActionTypes, ProjectEditSuccessAction} from '../actions/project-creation';
import {LoadProjectsAction} from '../../site/actions/projects-list';

@Injectable()
export class InvoicesManagementEffect extends BaseEffect {


  // @ts-ignore
  /*add$ = createEffect(() => { return this.actions$.pipe(
    ofType(addInvoiceManagementActionTypes.ADD),
    debug('update contract link action received.'),
    map((action: AddInvoiceManagementAction) => action.payload),
    switchMap((payload) =>
      this.invoicesManagementService.add(payload).pipe(
        // tslint:disable-next-line:no-any
          map((payloads: SendBackResult<any>) => of(new AddInvoiceManagementSuccessAction(payloads) , new LoadSubByClientListAction())),
          catchError(res => this.catchResponseError(res)),
        )))
  });*/

  add$ = createEffect(() => { return this.actions$.pipe(
    ofType(addInvoiceManagementActionTypes.ADD),
    debug('update contract link action received.'),
    map((action: AddInvoiceManagementAction) => action.payload),
    switchMap((payload) =>  this.invoicesManagementService.add(payload).pipe(
      // tslint:disable-next-line:no-any
      switchMap((data: SendBackResult<any>) => of( new AddInvoiceManagementSuccessAction(data) , new LoadSubByClientListAction() )),
      catchError(res => this.catchResponseError(res))))
  ) });

  addSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(addInvoiceManagementActionTypes.ADD_SUCCESS),
    debug('update success contract link action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(([data, client]) => [
      success(this.translation.translate('CONTRACT_LINK_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  addFail$ = createEffect(() => { return this.actions$.pipe(ofType(addInvoiceManagementActionTypes.ADD_FAIL),
    debug('A server error occurred while update contract.'),
    map((err: AddInvoiceManagementFailAction) =>
      error(this.translation.translate('CONTRACT_LINK_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private invoicesManagementService: InvoicesManagementService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new AddInvoiceManagementFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new AddInvoiceManagementFailAction(response['error'].message);
  }

}
